export default __webpack_public_path__ + "static/tooltip-truncation-do-light-ebd354e56502af5dc26660b7bca185ab.png";